import UserAvatar from "./UserAvatar";

const CardUserInput = ({ image, name, onClick }) => {

    return (
        <div onClick={onClick} style={{
            backgroundColor: "#E4EBFF",
            width: "90%",
            borderRadius: "60px",
            display: "flex",
            alignItems: "center",
            padding: "3px",
            gap: "10px",
            cursor: "pointer"
        }}>
            {
                image ? (
                    <img src={image} />
                )
                    :
                    (
                        <UserAvatar name={name} size={30} fontSize={11} />
                    )
            }

            <p className="textNameTableListManager">{name}</p>
        </div>
    )
}

export default CardUserInput